import { LazyMotion, domAnimation } from 'framer-motion';
import './App.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import Process from './components/Process';
import Services from './components/Services';
import About from './components/About';
import Statement from './components/Statement';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import Grain from './components/Grain';

export default function App() {
  return (
    <LazyMotion features={domAnimation}>
      <div className="font-sans antialiased">
        <Grain />
        <Nav />
        <main>
          <Hero />
          <Process />
          <Services />
          <About />
          <Statement />
          <CallToAction />
        </main>
        <Footer />
      </div>
    </LazyMotion>
  );
}
